import { PLATFORM_REGEXES } from '../constants'
import URLParser from '../URLParser'

const referrerHostname = traffic => {
  if (traffic.referrer === '') {
    return ''
  }
  const referrerObject = new URLParser(traffic.referrer)
  const hostname = referrerObject.hostname
  for (let platform in PLATFORM_REGEXES) {
    if (PLATFORM_REGEXES[platform].some(regex => regex.test(hostname))) {
      return platform
    }
  }
  return hostname
}

export default referrerHostname



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/selectors/referrerHostname.js